import React, { useState } from 'react';
import {
  callAdminLiveUserListing,
  updateMember,
  deleteMember,
  goToDashboard,
  fileExport,
} from '../../api-services';
import swal from 'sweetalert';
import MemberDetailsModal from './modal/MemberDetailsModal';
import AddMemberModal from './modal/AddMemberModal';
import Dropdown from 'react-bootstrap/Dropdown';
import { useMutation, useQueryClient } from 'react-query';
import UserEditModal from '../User/modal/UserEditModal';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEllipsisV,
  faEye,
  faEdit,
  faTrash,
  faUserSlash,
  faUser,
  faChartPie,
} from '@fortawesome/free-solid-svg-icons';
import Country from '../../components/Country';
import { Country as GlobalCountries } from 'country-state-city';
import TableManager from '../../components/TableManager';
import Greetings from './modal/Greetings';
import { createTable } from '@tanstack/react-table';
import { openUserDetailsModal } from '../../redux/features/modalSlice';
import { useDispatch } from 'react-redux';
import Bundles from './modal/Bundles';
import LiveUsersUpload from './modal/LiveUsersUpload';

const table = createTable();

const numberFilterTypes = [
  { label: 'Less Than', value: 'less_than' },
  { label: 'Greater Than', value: 'greater_than' },
  { label: 'Is Equal To', value: 'is_equal' },
  { label: 'Is Not Equal To', value: 'is_not_equal' },
  { label: 'Less or Equal to', value: 'less_or_equal' },
  { label: 'Greater or Equal to', value: 'greater_or_equal' },
];
const currencyOptions = [
  { label: 'EURO', value: 'EURO' },
  { label: 'XOF', value: 'XOF' },
  { label: 'USD', value: 'USD' },
  { label: 'GBP', value: 'GBP' },
  { label: 'NGN', value: 'NGN' },
];
const DateFilterTypes = [
  { label: 'Today', value: 'Today' },
  { label: 'Yesterday', value: 'Yesterday' },
  { label: 'Last 7 Days', value: 'Last 7 Days' },
  { label: 'Last 30 Days', value: 'Last 30 Days' },
  { label: 'This Month', value: 'This Month' },
  { label: 'Last Month', value: 'Last Month' },
  { label: 'Custom', value: 'Custom' },
];

const statusOptions = [
  { label: 'Active', value: 'A' },
  { label: 'Deactive', value: 'D' },
];

const initialValues = {
  filter: [
    // {
    //   firstname: '',
    //   a_filter_type: '',
    //   placeholder: 'Enter Firstname...',
    //   type: 'text',
    //   shouldFilterOptionDisabled: false,
    //   label: 'Firstname',
    // },
    {
      account_number: '',
      a_filter_type: '',
      placeholder: 'Enter MSISDN...',
      type: 'number',
      shouldFilterOptionDisabled: false,
      // filterOptions: numberFilterTypes,
      label: 'MSISDN',
    },
    {
      email: '',
      a_filter_type: '',
      placeholder: 'Enter Email...',
      type: 'text',
      shouldFilterOptionDisabled: false,
      label: 'Email',
    },
    {
      phone: '',
      a_filter_type: '',
      placeholder: 'Enter Phone...',
      type: 'text',
      shouldFilterOptionDisabled: false,
      label: 'Phone',
    },
    {
      country: '',
      a_filter_type: '',
      placeholder: 'Select Country...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: GlobalCountries?.getAllCountries(),
      label: 'Country',
    },
    {
      currency: '',
      a_filter_type: '',
      placeholder: 'Select Currency...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: currencyOptions,
      label: 'Currency',
    },
    {
      credit: '',
      a_filter_type: '',
      placeholder: 'Enter Credit...',
      type: 'number',
      shouldFilterOptionDisabled: false,
      filterOptions: numberFilterTypes,
      label: 'Credit',
    },
    {
      status: '',
      a_filter_type: '',
      placeholder: 'Select Status...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: statusOptions,
      label: 'Status',
    },
    {
      date: {
        from: '',
        to: '',
      },
      a_filter_type: '',
      placeholder: 'Custom Date Range...',
      type: 'date',
      shouldFilterOptionDisabled: false,
      filterOptions: DateFilterTypes,
      selectOptions: [],
      label: 'Date',
    },
  ],
};

const LiveUsersListing = () => {
  const [editData, setEditData] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [openModalUser, setOpenModalUser] = useState(false);
  const [openGreetings, setOpenModalGreetings] = useState(false);
  const [openBundle, setOpenModalBundle] = useState(false);
  const [greetingData, setGreetingData] = useState([]);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [filters, setFilters] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [customerUniqueCode, setCustomerUniqueCode] = useState('');
  const [isUpload, setUploadUsers] = useState(false);

  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleOpenGreeting = (did_numbers) => {
    if (did_numbers?.length > 0) {
      setGreetingData(did_numbers);
      setOpenModalGreetings(true);
    } else {
      return false;
    }
  };

  const handleOpenBundle = (bundles, data) => {
    setCustomerUniqueCode(data?.uniquecode);
    if (bundles?.length > 0) {
      setOpenModalBundle(true);
    } else {
      return false;
    }
  };

  const { mutateAsync: mutateAsyncLogin } = useMutation(
    'login-web-user',
    (payload) => goToDashboard(payload),
    {
      onSuccess: (data) => {
        window.open(
          `${process.env.REACT_APP_TOKEN_URL}?access=${data?.data?.data?.access_token}&refresh=${data?.data?.data?.refresh_token}`,
        );
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );

  const { isLoading: isLoadingExporting, mutateAsync: mutateAsyncExport } =
    useMutation(
      'fileExport',
      (payload) => fileExport(payload, 'customer/live'),
      {
        onSuccess: (data) => {
          window.open(data?.data?.data);
        },
        onError: (error) => {
          swal({
            title: error?.response?.data?.message,
            type: 'danger',
            icon: 'error',
          });
        },
      },
    );

  const { mutateAsync: mutateAsyncdelete } = useMutation(
    'delete-user',
    deleteMember,
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message,
          icon: 'success',
          type: 'success',
          timer: 2000,
        }).then(() => {
          queryClient.invalidateQueries('UserListing');
        });
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );
  const { mutateAsync: mutateAsyncActive } = useMutation(
    'update-user',
    updateMember,
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message,
          icon: 'success',
        }).then(() => {
          queryClient.invalidateQueries('UserListing');
        });
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );

  const deleteUserList = (value) => {
    swal({
      text: 'Are you sure you want to delete this User ?',
      buttons: true,
      icon: 'warning',
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          let payload = {
            uniquecode: value?.uniquecode,
          };
          await mutateAsyncdelete(payload);
        } catch (error) {
          console.log(error);
        }
      }
    });
  };

  const handleUserDetailsModal = (data) => {
    dispatch(
      openUserDetailsModal({
        userModalOpen: true,
        userModalData: data,
      }),
    );
  };

  const handleDeactivateBtn = async (data, uniquecode) => {
    let payload = {
      status: data,
      uniquecode,
      password: null,
    };
    swal({
      text: 'Do You Want To Deactivate This User ?',
      icon: 'warning',
      buttons: true,
    }).then(async (willDeactive) => {
      if (willDeactive) {
        try {
          await mutateAsyncActive(payload);
        } catch (error) {
          console.error(error);
        }
      }
    });
  };

  const handleActivateBtn = async (data, uniquecode) => {
    let payload = {
      status: data,
      uniquecode,
      password: null,
    };
    swal({
      text: 'Do You Want To Activate This User ?',
      icon: 'warning',
      buttons: true,
    }).then(async (willActivate) => {
      if (willActivate) {
        try {
          await mutateAsyncActive(payload);
        } catch (error) {
          console.error(error);
        }
      }
    });
  };

  const handleAddMember = () => {
    setOpenModalUser(true);
  };
  const handleEditData = (data) => {
    const payload = {
      firstname: data?.firstname ?? '',
      lastname: data?.lastname ?? '',
      country: data?.country ?? '',
      email: data?.email ?? '',
      phone: data?.phone ?? '',
      password: data?.password ?? null,
      confirm_password: data?.confirm_password ?? null,
      uniquecode: data?.uniquecode ?? '',
      address: data?.address ?? '',
      push_notification: data?.settings?.push_notification === 0 ? false : true,
      email_notification:
        data?.settings?.email_notification === 0 ? false : true,
      sms_notification: data?.settings?.sms_notification === 0 ? false : true,
      auto_topup: data?.settings?.auto_topup === 0 ? false : true,
    };
    setEditData(payload);
    setOpenModalUser(true);
  };

  const handleUserLogin = async ({ uniquecode }) => {
    await mutateAsyncLogin({ uniquecode });
  };

  const handleFileExport = async (payload) => {
    await mutateAsyncExport(payload);
  };

  const uploadLiveUsersFile = () => {
    setUploadUsers(true);
  };
  const columns = [
    table.createDataColumn('created_at', {
      id: 'created_at',
      header: 'Registered On',
      cell: (props) => moment(props.getValue()).format('YYYY-MM-DD: HH:mm:ss'),
      isSortable: true,
    }),
    table.createDataColumn('msisdn', {
      id: 'msisdn',
      header: 'MSISDN',
    }),
    table.createDataColumn('email', {
      id: 'email',
      header: 'Email',
      textAlign: 'left',
    }),
    table.createDataColumn('phone', {
      id: 'phone',
      header: 'Phone',
    }),
    table.createDataColumn('country', {
      id: 'country',
      header: 'Country',
      cell: (props) => <Country isoCode={props.getValue()} />,
      textAlign: 'left',
    }),
    table.createDataColumn('currency', {
      id: 'currency',
      header: 'Currency',
    }),
    table.createDataColumn('credit', {
      id: 'credit',
      header: 'Credit',
      isSortable: true,
    }),
    table.createDataColumn('status', {
      id: 'status',
      header: 'Status',
      cell: (props) =>
        props.getValue() === 'Active' ? (
          <a className="text-success" href="#">
            Activated
          </a>
        ) : (
          <a className="text-danger" href="#">
            Deactivated
          </a>
        ),
    }),
    table.createDataColumn('did_numbers', {
      id: 'did_numbers',
      header: 'Greeting',
      cell: (props) => (
        <button
          type="button"
          disabled={!props.getValue()?.length}
          className="btn btn-primary d-flex align-items-center justify-content-center  reload_icon pointer mx-auto"
          onClick={() => handleOpenGreeting(props.getValue())}
        >
          {props.getValue()?.length || '0'}
        </button>
      ),
      // isSortable: true,
    }),
    table.createDataColumn('bundle', {
      id: 'bundle',
      header: 'Bundle',
      cell: (props) => (
        <button
          type="button"
          disabled={!props.getValue()?.length}
          className="btn btn-primary d-flex align-items-center justify-content-center  reload_icon pointer mx-auto"
          onClick={() => handleOpenBundle(props.getValue(), props.row.original)}
        >
          {props.getValue()?.length || '0'}
        </button>
      ),
      isSortable: true,
    }),
    table.createDisplayColumn({
      id: 'action',
      header: 'Action',
      cell: (props) => (
        <span>
          <Dropdown className="dropdown_dot mx-auto">
            <Dropdown.Toggle
              id="dropdown-basic"
              className="btn-light-blue btn-action "
            >
              <FontAwesomeIcon icon={faEllipsisV} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                href={void 0}
                onClick={() => handleUserDetailsModal(props.row.original)}
              >
                <FontAwesomeIcon icon={faEye} /> View
              </Dropdown.Item>
              <Dropdown.Item
                href={void 0}
                onClick={() => handleEditData(props.row.original)}
              >
                <FontAwesomeIcon icon={faEdit} /> Edit
              </Dropdown.Item>
              <Dropdown.Item
                href={void 0}
                onClick={() => deleteUserList(props.row.original)}
              >
                <FontAwesomeIcon icon={faTrash} />
                Delete
              </Dropdown.Item>
              {props.row.original.status === 'Active' ? (
                <Dropdown.Item
                  href={void 0}
                  onClick={() =>
                    handleDeactivateBtn('D', props.row.original.uniquecode)
                  }
                >
                  <FontAwesomeIcon icon={faUserSlash} />
                  Deactivate
                </Dropdown.Item>
              ) : (
                <Dropdown.Item
                  href={void 0}
                  onClick={() =>
                    handleActivateBtn('A', props.row.original.uniquecode)
                  }
                >
                  <FontAwesomeIcon icon={faUser} />
                  Activate
                </Dropdown.Item>
              )}

              <Dropdown.Item
                href={void 0}
                onClick={() => handleUserLogin(props.row.original)}
              >
                <FontAwesomeIcon icon={faChartPie} /> Go to dashboard
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </span>
      ),
    }),
  ];

  return (
    <>
      <TableManager
        table={table}
        columns={columns}
        filter={filters}
        title="Live Users"
        fetcherKey="liveUserListing"
        fetcherFn={callAdminLiveUserListing}
        cta={true}
        ctaFunction={handleAddMember}
        uploadLiveUsersFunction={uploadLiveUsersFile}
        ctaLabel="Add Customer"
        shouldFilter={true}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        initialValues={initialValues}
        setFilters={setFilters}
        filters={filters}
        shouldExport={true}
        exportCtaFn={handleFileExport}
        isExporting={isLoadingExporting}
        uploadFile={true}
      />

      {openModal && (
        <MemberDetailsModal
          setOpenModal={setOpenModal}
          setModalData={setModalData}
          data={modalData}
          openModal={openModal}
        />
      )}

      {openEditModal && (
        <UserEditModal
          setOpenEditModal={setOpenEditModal}
          setModalData={setModalData}
          modalData={modalData}
          openEditModal={openEditModal}
        />
      )}

      {openModalUser && (
        <AddMemberModal
          setOpenModal={setOpenModalUser}
          openModal={openModalUser}
          editData={editData}
          setEditData={setEditData}
        />
      )}
      {openGreetings && (
        <Greetings
          setOpenModal={setOpenModalGreetings}
          openModal={openGreetings}
          greetingData={greetingData}
          setGreetingData={setGreetingData}
        />
      )}
      {openBundle && (
        <Bundles
          setOpenModal={setOpenModalBundle}
          openModal={openBundle}
          customerUniqueCode={customerUniqueCode}
          setCustomerUniqueCode={setCustomerUniqueCode}
        />
      )}
      {isUpload && (
        <LiveUsersUpload
          setOpenModal={setUploadUsers}
          openModal={isUpload}
          // AllProvidersCall={AllProvidersCall}
        />
      )}
    </>
  );
};

export default LiveUsersListing;
